export const API_URL_CONFIG = 'https://devapi.dbraei.edu.in/api/v1/';
export const IMG_URL_CONFIG = 'https://vilassetmanagement.blob.core.windows.net/atumlifeapp/';
export const IMG_CONTAINER = 'dbraei-dev';
export const isProduction =false;
export const ASSET_URL_CONFIG = 'https://dbraeiassetmanagement.blob.core.windows.net/';
export const ASSET_CONTAINER_NAME = 'dbraei-dev';
